import { render, staticRenderFns } from "./claim-goods-input-case.vue?vue&type=template&id=1d32df0b&scoped=true&"
import script from "./claim-goods-input-case.vue?vue&type=script&lang=js&"
export * from "./claim-goods-input-case.vue?vue&type=script&lang=js&"
import style0 from "./claim-goods-input-case.vue?vue&type=style&index=0&id=1d32df0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d32df0b",
  null
  
)

export default component.exports